function truncFraction(num: string | number, digits: number) {
  const factor = 10 ** digits;
  return Math.floor(Number(num) * factor) / factor;
}

export const formatOdds = (num: string | number) => truncFraction(num, 2);
